function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgLayersBlue = function SvgLayersBlue(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.997 511.997",
    style: {
      enableBackground: "new 0 0 511.997 511.997"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "255.999,396.073 10.084,255.572 103.365,202.604 255.999,289.809  "
  }), React.createElement("polygon", {
    style: {
      fill: "#A4C2F7"
    },
    points: "255.999,9.658 501.913,149.308 255.999,289.809  "
  }), React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "255.999,289.383 10.084,149.733 255.999,9.232  "
  }), React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.3023,
    y1: 651.9642,
    x2: -48.3023,
    y2: 651.9642,
    gradientTransform: "matrix(395.2253 0 0 -260.8302 19543.8965 170201.6875)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.1717,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.2001,
    style: {
      stopColor: "#DAE4F4"
    }
  }), React.createElement("stop", {
    offset: 0.2007,
    style: {
      stopColor: "#EBEBF4"
    }
  }), React.createElement("stop", {
    offset: 0.2014,
    style: {
      stopColor: "#F6F1F4"
    }
  }), React.createElement("stop", {
    offset: 0.2023,
    style: {
      stopColor: "#FDF4F4"
    }
  }), React.createElement("stop", {
    offset: 0.205,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.2522,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.3974,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.4201,
    style: {
      stopColor: "#DAE4F4"
    }
  }), React.createElement("stop", {
    offset: 0.4207,
    style: {
      stopColor: "#EBEBF4"
    }
  }), React.createElement("stop", {
    offset: 0.4214,
    style: {
      stopColor: "#F6F1F4"
    }
  }), React.createElement("stop", {
    offset: 0.4223,
    style: {
      stopColor: "#FDF4F4"
    }
  }), React.createElement("stop", {
    offset: 0.425,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.4894,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#F9F2F4"
    }
  }), React.createElement("stop", {
    offset: 0.5001,
    style: {
      stopColor: "#E8EBF4"
    }
  }), React.createElement("stop", {
    offset: 0.5003,
    style: {
      stopColor: "#DDE5F4"
    }
  }), React.createElement("stop", {
    offset: 0.5005,
    style: {
      stopColor: "#D6E2F4"
    }
  }), React.createElement("stop", {
    offset: 0.501,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.7062,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.8346,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.851,
    style: {
      stopColor: "#D4E1F4"
    }
  })), React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    points: "453.611,149.308 255.999,280.148 58.386,149.308 255.999,19.318  "
  }), React.createElement("polygon", {
    style: {
      fill: "#A4C2F7"
    },
    points: "255.999,396.073 501.913,255.572 408.633,202.604 255.999,289.809  "
  }), React.createElement("polygon", {
    style: {
      fill: "#E3E7F2"
    },
    points: "251.594,289.809 131.679,218.186 38.399,271.154 251.594,396.073 464.122,270.488  377.179,222.186  "
  }), React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "255.999,502.598 10.084,362.097 103.365,309.129 255.999,396.333  "
  }), React.createElement("polygon", {
    style: {
      fill: "#A4C2F7"
    },
    points: "255.999,502.598 501.913,362.097 408.633,309.129 255.999,396.333  "
  }), React.createElement("polygon", {
    style: {
      fill: "#E3E7F2"
    },
    points: "251.594,396.333 131.679,324.721 38.399,377.689 251.594,502.598 464.122,377.013  377.179,328.711  "
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M255.999,299.469c-1.681,0-3.333-0.439-4.793-1.274L5.291,157.695 c-3.008-1.719-4.866-4.917-4.868-8.382c-0.002-3.465,1.852-6.665,4.858-8.387l125.585-72.028 c4.625-2.605,10.485-0.991,13.123,3.615c2.638,4.606,1.067,10.477-3.52,13.149L29.527,149.294l226.472,129.387l226.396-129.349 L255.866,20.691l-57.67,30.943c-4.701,2.51-10.546,0.739-13.064-3.957c-2.518-4.696-0.759-10.544,3.932-13.072l62.368-33.462 c2.927-1.564,6.451-1.521,9.34,0.113l245.915,139.651c3.017,1.715,4.883,4.917,4.887,8.388c0.004,3.471-1.854,6.677-4.868,8.399 l-245.916,140.5C259.331,299.03,257.68,299.469,255.999,299.469L255.999,299.469z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M255.999,405.733c-1.681,0-3.333-0.439-4.793-1.274L5.291,263.959 c-3.014-1.722-4.872-4.928-4.868-8.399c0.004-3.471,1.869-6.673,4.887-8.388L98.593,194.2c2.968-1.684,6.603-1.679,9.566,0.014 l147.84,84.467l147.849-84.467c2.963-1.693,6.599-1.698,9.566-0.014l93.274,52.972c3.018,1.715,4.883,4.917,4.887,8.388 c0.004,3.471-1.854,6.677-4.868,8.399l-245.916,140.5C259.331,405.294,257.68,405.733,255.999,405.733z M29.602,255.596 l226.397,129.349l226.396-129.349l-73.736-41.878L260.79,298.195c-2.969,1.698-6.616,1.698-9.585,0l-147.858-84.476 L29.602,255.596z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M255.999,511.997c-1.681,0-3.333-0.439-4.793-1.274L5.291,370.224 c-3.014-1.722-4.872-4.928-4.868-8.399c0.004-3.471,1.869-6.673,4.887-8.388l93.283-52.972c2.968-1.684,6.603-1.679,9.566,0.014 l147.84,84.467l147.849-84.467c2.963-1.693,6.599-1.698,9.566-0.014l93.274,52.972c3.018,1.715,4.883,4.917,4.887,8.388 c0.004,3.471-1.854,6.677-4.868,8.399l-245.916,140.5C259.331,511.558,257.68,511.997,255.999,511.997L255.999,511.997z  M29.602,361.86l226.397,129.349L482.394,361.86l-73.736-41.878L260.79,404.459c-2.969,1.698-6.616,1.698-9.585,0l-147.858-84.476 L29.602,361.86z"
  }), React.createElement("circle", {
    style: {
      fill: "#428DFF"
    },
    cx: 164.67,
    cy: 57.959,
    r: 9.66
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLayersBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/layers-blue.cd57358f.svg";
export { ForwardRef as ReactComponent };